/**
 * PannableRect Component
 *
 * Reusable SVG rect wrapper that enables click-and-drag panning interaction.
 * Analogous to PhaseIntersectionHandle — a modular, self-contained interaction unit.
 *
 * Marks itself data-interactive="true" so the outer useTimelineDragPan does not
 * also fire when the user initiates a pan on this element.
 *
 * Cursor: 'move' on hover, 'grabbing' while actively panning.
 */
export const PannableRect = ({
  // SVG geometry
  x,
  y,
  width,
  height,
  // SVG style
  fill,
  rx,
  stroke,
  strokeWidth,
  opacity,
  // Pan interaction
  isPanning,        // Boolean — this specific rect is currently being panned
  onPanStart,       // (clientX: number) => void — called on mousedown
  // Hover forwarding (so parent can update hovered state for bookmarks etc.)
  onMouseEnter,
  onMouseLeave,
  // Icon and other overlays
  children,
  // Any extra props (e.g. data-* attributes) are forwarded to the inner rect
  ...extraProps
}) => {
  const handleMouseDown = (e) => {
    if (e.button !== 0) return
    e.stopPropagation()
    e.preventDefault()
    onPanStart(e.clientX)
  }

  return (
    <g data-interactive="true">
      <rect
        {...extraProps}
        x={x}
        y={y}
        width={width}
        height={height}
        fill={fill}
        rx={rx}
        stroke={stroke}
        strokeWidth={strokeWidth}
        opacity={opacity}
        onMouseDown={handleMouseDown}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{ cursor: isPanning ? 'grabbing' : 'move' }}
      />
      {children}
    </g>
  )
}
